export default __webpack_public_path__ + "static/media/ISEO CLASS 1 SYLLABUS.7240d2f0.pdf";